import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { user, isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // Check if there's a session_id in the URL (OAuth callback)
  // Check both hash and query params
  const params = new URLSearchParams(location.search);
  const hash = location.hash;
  const hasSessionId = params.has('session_id') || (hash && hash.includes('session_id='));

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        flexDirection: 'column',
        gap: '1rem'
      }}>
        <div style={{
          width: '50px',
          height: '50px',
          border: '4px solid #e2e8f0',
          borderTopColor: '#4ade80',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }}></div>
        <p style={{ color: '#64748b' }}>Loading...</p>
      </div>
    );
  }

  // Allow access if user is authenticated OR if there's a session_id (OAuth callback in progress)
  if (!isAuthenticated && !hasSessionId) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check admin role if required
  if (requireAdmin && isAuthenticated) {
    if (user?.role !== 'admin') {
      // Redirect non-admin users to dashboard
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;